<template>
  <div class="row">
    <div class="col-md-12 col-lg-12">
      <c-table ref="substanceTable" title="구성성분 목록" tableId="substanceTable" :columns="grid.columns" :data="grid.data" :columnSetting="false" selection="multiple" rowKey="mdmChemId" :filtering="false" :usePaging="false" :hideBottom="true" gridHeight="400px" :editable="editable" checkDisableColumn="noFlag" @linkClick="linkClick" @table-data-change="tableDataChange">
        <!-- <template slot="customComment">
          <div class="row q-col-gutter-sm">
            <div class="col-6">
              <c-table
                dense
                hideBottom
                gridHeightAuto
                :usePaging="false"
                :isExcelDown="false"
                :columnSetting="false"
                title="PRTR Ⅰ 그룹"
                :columns="prtrColumns"
                :data="prtr1rows"
                rowKey="casNo"
              />
            </div>
            <div class="col-6">
              <c-table
                dense
                hideBottom
                gridHeightAuto
                :usePaging="false"
                :isExcelDown="false"
                :columnSetting="false"
                title="PRTR Ⅱ 그룹"
                :columns="prtrColumns"
                :data="prtr2rows"
                rowKey="casNo"
              />
            </div>
          </div>
        </template> -->

        <template v-slot:customArea="{ props, col }">
          <template v-if="['twaPpm', 'twaMm', 'stelPpm', 'stelMm'].includes(col.name)">
            <c-text-column v-if="props.row.regulTwaStel > 0" :editable="editable" :props="props" :col="col" v-model="props.row[col.name]" @datachange="datachange(props)" />
            <span v-else>{{ props.row[col.name] }}</span>
          </template>

          <template v-if="col.name === 'regulationQuantityDose'">
            <c-text-column v-if="props.row.regulQuanti > 0" :editable="editable" :props="props" :col="col" v-model="props.row[col.name]" @datachange="datachange(props)" />
            <span v-else>{{ props.row[col.name] }}</span>
          </template>

          <template v-if="['prtrSwcsWtQuantity', 'prtrSwcsTonQuantity'].includes(col.name)">
            <c-text-column v-if="props.row.regulD10 > 0" :editable="editable" :props="props" :col="col" v-model="props.row[col.name]" @datachange="datachange(props)" />
            <span v-else>{{ props.row[col.name] }}</span>
          </template>

          <template v-if="['dangerousClass', 'dangerousProp', 'dangerousName', 'calcuOriginal', 'calcuMultiple'].includes(col.name)">
            <template v-if="props.row.regulD14 > 0 && !props.row.dangerousClass">
              <div v-if="col.name === 'dangerousName'" class="merged-msg-container">위안법 물질입니다. 허가배수 관리 메뉴에서 사업장 총 허가배수를 등록바랍니다.</div>
            </template>
            <span v-else>{{ props.row[col.name] }}</span>
          </template>
        </template>

        <template slot="table-button">
          <q-btn-group outline>
            <c-btn label="규제 판단 기준 매뉴얼" icon="help_outline" color="info" @btnClicked="openManual" />
            <c-checkbox isFlag noborder falseLabel="삭제물질 포함" trueLabel="삭제물질 포함" name="delFlag" addClasses="chemComponentsCheckbox" v-model="delFlag" @input="getDetail" />
            <c-btn v-if="editable" label="LBLADD" icon="add" @btnClicked="addRow" />
            <c-btn v-if="editable && grid.data.length > 0" label="LBLSAVE" icon="save" @btnClicked="saveSubstance" />
            <c-btn v-if="editable && grid.data.length > 0" label="LBLREMOVE" icon="remove" @btnClicked="removeRow" />
          </q-btn-group>
        </template>
      </c-table>
    </div>

    <div class="col-12">
      <c-table ref="innertable" tableId="innertable" title="구성성분별 규제사항" class="topcolor-orange" :columns="grid2.columns" :data="grid2.data" :columnSetting="false" :filtering="false" :usePaging="false" :hideBottom="true" :editable="false" :gridHeight="innertableHeight">
        <template slot="suffixTitle">
          <q-btn-group outline>
            &nbsp; &nbsp; &nbsp;
            <c-btn v-if="editable" label="규제항목 기준값 조회" icon="history" @btnClicked="openChemQuantity" />
          </q-btn-group>
        </template>
      </c-table>
    </div>
    <c-dialog :param="popupOptions" />
    <ChemUpdateManualDialog v-model="manualVisible" />
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
import ChemUpdateManualDialog from '@/pages/mdm/mam/form/chemUpdateManualDialog.vue';

export default {
  name: 'chemComponents',
  components: {
    ChemUpdateManualDialog, // 2. 컴포넌트 등록
  },
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        mdmChemMaterialId: '',
        tabName: '',
        subtabName: '',
        plantCd: null,
      }),
    },
    chemData: { type: Object, default: () => ({}) },
    contentHeight: [Number, String],
  },
  data() {
    return {
      editable: true,
      manualVisible: false,
      delFlag: 'N',
      innertableHeight: '300px',
      listUrl: '',
      saveUrl: '',
      autoSaveUrl: '',
      deleteUrl: '',
      reglistUrl: '',
      headerUrl: '',
      prtr2Url: '',
      grid: { columns: [], data: [] },
      grid2: { columns: [], data: [] },
      popupOptions: {
        isFull: false,
        target: null,
        title: '',
        visible: false,
        param: {},
        closeCallback: null,
      },
      //     prtr1rows: [
      //       {
      //         no: "1",
      //         casNo: "000050-00-0",
      //         krName: "포름알데히드",
      //         enName: "Formaldehyde",
      //         rate: "0.1 이상",
      //       },
      //       {
      //         no: "2",
      //         casNo: "000056-53-1",
      //         krName: "디에틸스틸베스테롤",
      //         enName: "Diethylstilbesterol",
      //         rate: "0.1 이상",
      //       },
      //       {
      //         no: "3",
      //         casNo: "000071-43-2",
      //         krName: "벤젠",
      //         enName: "Benzene",
      //         rate: "0.1 이상",
      //       },
      //       {
      //         no: "4",
      //         casNo: "000075-01-4",
      //         krName: "염화 비닐",
      //         enName: "Vinyl chloride",
      //         rate: "0.1 이상",
      //       },
      //       {
      //         no: "5",
      //         casNo: "000075-21-8",
      //         krName: "산화 에틸렌",
      //         enName: "Ethylene oxide",
      //         rate: "0.1 이상",
      //       },
      //       {
      //         no: "6",
      //         casNo: "000079-01-6",
      //         krName: "트리클로로에틸렌",
      //         enName: "Trichloroethylene",
      //         rate: "0.1 이상",
      //       },
      //       {
      //         no: "7",
      //         casNo: "000095-53-4",
      //         krName: "o-톨루이딘",
      //         enName: "o-Toluidine",
      //         rate: "0.1 이상",
      //       },
      //       {
      //         no: "8",
      //         casNo: "000101-14-4",
      //         krName: `3,3'-디클로로-4,4'-디아미노디페닐 메탄`,
      //         enName: `3,3'-Dichloro-4,4'-diaminodiphenylmethane`,
      //         rate: "0.1 이상",
      //       },
      //       {
      //         no: "9",
      //         casNo: "000106-99-0",
      //         krName: `1,3-부타디엔`,
      //         enName: `1,3-Butadiene`,
      //         rate: "0.1 이상",
      //       },
      //       {
      //         no: "10",
      //         casNo: "000107-30-2",
      //         krName: `클로로메틸 메틸 에테르`,
      //         enName: `Chloromethyl methyl ether`,
      //         rate: "0.1 이상",
      //       },
      //       {
      //         no: "11",
      //         casNo: "000193-39-5",
      //         krName: `인데노[1,2,3-cd]피렌`,
      //         enName: `Indeno[1,2,3-cd]pyrene`,
      //         rate: "0.1 이상",
      //       },
      //       {
      //         no: "12",
      //         casNo: "000298-81-7",
      //         krName: `8-메톡시-6,7-푸라노쿠마린`,
      //         enName: `8-Methoxy-6,7-furanocoumarin`,
      //         rate: "0.1 이상",
      //       },
      //       {
      //         no: "13",
      //         casNo: "001332-21-4",
      //         krName: `석면`,
      //         enName: `Asbestos`,
      //         rate: "0.1 이상",
      //       },
      //       {
      //         no: "14",
      //         casNo: "NA-(주1)",
      //         krName: `납 및 그 화합물`,
      //         enName: `Lead and its compounds`,
      //         rate: "0.1 이상",
      //       },
      //       {
      //         no: "15",
      //         casNo: "NA-(주2)",
      //         krName: `수은 및 그 화합물`,
      //         enName: `Mercury and its compounds`,
      //         rate: "0.1 이상",
      //       },
      //       {
      //         no: "16",
      //         casNo: "NA-(주3)",
      //         krName: `니켈 및 그 화합물`,
      //         enName: `Nickel and its compounds`,
      //         rate: "0.1 이상",
      //       },
      //       {
      //         no: "17",
      //         casNo: "NA-(주4)",
      //         krName: `비소 및 그 화합물`,
      //         enName: `Arsenic and its compounds`,
      //         rate: "0.1 이상",
      //       },
      //       {
      //         no: "18",
      //         casNo: "NA-(주5)",
      //         krName: `베릴륨 및 그 화합물`,
      //         enName: `Beryllium and its compounds`,
      //         rate: "0.1 이상",
      //       },
      //       {
      //         no: "19",
      //         casNo: "NA-(주6)",
      //         krName: `카드뮴 및 그 화합물`,
      //         enName: `Cadmium and its compounds`,
      //         rate: "0.1 이상",
      //       },
      //       {
      //         no: "20",
      //         casNo: "NA-(주7)",
      //         krName: `크롬 및 그 화합물`,
      //         enName: `Chromium and its compounds`,
      //         rate: "0.1 이상",
      //       },
      //     ],
      //     prtr2rows: [],
      //     prtrColumns: [
      //       { name: "no", field: "no", label: "번호", align: "center" },
      //       {
      //         name: "casNo",
      //         field: "casNo",
      //         label: "CAS No.",
      //         align: "center",
      //         style: "width: 160px",
      //       },
      //       {
      //         name: "krName",
      //         field: "krName",
      //         label: "품명(국문명)",
      //         align: "left",
      //       },
      //       {
      //         name: "enName",
      //         field: "enName",
      //         label: "품명(영문명)",
      //         align: "left",
      //       },
      //       {
      //         name: "rate",
      //         field: "rate",
      //         label: "무게함유율(%)",
      //         align: "center",
      //       },
      //     ],
    };
  },
  watch: {
    contentHeight(val) {
      this.innertableHeight = val - 600 + 'px';
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.editable = Boolean(this.$route.meta.editable);
      this.headerUrl = selectConfig.mdm.mam.chem.header.url;
      this.listUrl = selectConfig.mdm.mam.chem.substance.url;
      this.autoSaveUrl = transactionConfig.mdm.mam.chem.substance.autoSave.url;
      this.saveUrl = transactionConfig.mdm.mam.chem.substance.save.url;
      this.deleteUrl = transactionConfig.mdm.mam.chem.substance.delete.url;
      this.reglistUrl = selectConfig.mdm.mam.chem.substance.regulate.url;
      // this.prtr2Url = selectConfig.chm.inout.emissions.prtr2.url;

      this.innertableHeight = window.innerHeight - 600 + 'px';

      this.tableHeaderSet();
      this.getHeader();
      this.getPrtr2();
      this.getDetail();
    },
    openManual() {
      this.manualVisible = true;
    },
    tableHeaderSet() {
      this.grid.columns = [
        {
          name: 'chemNmEn',
          field: 'chemNmEn',
          label: '화학물질명(ENG)',
          align: 'left',
          type: 'link',
          style: 'width:300px',
          fix: true,
        },
        {
          name: 'casNo',
          field: 'casNo',
          label: 'CAS No.',
          align: 'center',
          style: 'width:120px',
        },
        {
          name: 'molecularFormula',
          field: 'molecularFormula',
          label: '분자식',
          align: 'center',
          style: 'width:120px',
        },
        {
          label: '함유량(%)',
          align: 'center',
          child: [
            {
              name: 'limitDisplay',
              field: 'limitDisplay',
              label: '표시',
              align: 'center',
              style: 'width:120px',
              type: 'text',
            },
            {
              name: 'limitHigh',
              field: 'limitHigh',
              label: '상한',
              align: 'center',
              style: 'width:90px',
              type: 'number',
            },
            {
              name: 'limitLow',
              field: 'limitLow',
              label: '하한',
              align: 'center',
              style: 'width:90px',
              type: 'number',
            },
            {
              name: 'limitRepval',
              field: 'limitRepval',
              label: '대표값',
              align: 'center',
              style: 'width:80px',
              type: 'number',
            },
          ],
        },
        {
          name: 'regulationQuantityDose',
          field: 'regulationQuantityDose',
          label: '규정수량(kg)',
          align: 'right',
          style: 'width:80px',
          type: 'custom',
        },
        {
          label: 'PRTR 정량값',
          helpcommentCustom: true,
          align: 'center',
          child: [
            {
              name: 'prtrSwcsWtQuantity',
              field: 'prtrSwcsWtQuantity',
              label: '함유량(%)',
              align: 'right',
              style: 'width:90px',
              type: 'custom',
            },
            {
              name: 'prtrSwcsTonQuantity',
              field: 'prtrSwcsTonQuantity',
              label: '취급량(톤)',
              align: 'right',
              style: 'width:90px',
              type: 'custom',
            },
          ],
        },
        {
          label: '노출기준',
          align: 'center',
          child: [
            {
              name: 'twaPpm',
              field: 'twaPpm',
              label: 'TWA(p)',
              align: 'right',
              type: 'custom',
              style: 'width:70px',
            },
            {
              name: 'twaMm',
              field: 'twaMm',
              label: 'TWA(m)',
              align: 'right',
              type: 'custom',
              style: 'width:70px',
            },
            {
              name: 'stelPpm',
              field: 'stelPpm',
              label: 'STEL(p)',
              align: 'right',
              type: 'custom',
              style: 'width:70px',
            },
            {
              name: 'stelMm',
              field: 'stelMm',
              label: 'STEL(m)',
              align: 'right',
              type: 'custom',
              style: 'width:70px',
            },
          ],
        },
        {
          name: 'businessSecFlag',
          field: 'businessSecFlag',
          label: '영업비밀',
          align: 'center',
          style: 'width:80px',
          type: 'check',
          true: 'Y',
          false: 'N',
        },
        {
          name: 'delFlag',
          field: 'delFlag',
          label: '삭제여부',
          align: 'center',
          style: 'width:80px',
        },
        {
          label: 'CMR',
          align: 'center',
          child: [
            {
              name: 'cmrFlag',
              field: 'cmrFlag',
              label: '물질여부',
              align: 'center',
              style: 'width:70px',
              sortable: false,
            },
            {
              name: 'carcinogens',
              field: 'carcinogens',
              label: '발암성',
              align: 'center',
              style: 'width:90px',
              sortable: false,
            },
            {
              name: 'mutagens',
              field: 'mutagens',
              label: '변이원성',
              align: 'center',
              style: 'width:90px',
              sortable: false,
            },
            {
              name: 'reproductiveToxins',
              field: 'reproductiveToxins',
              label: '생식독성',
              align: 'center',
              style: 'width:90px',
              sortable: false,
            },
          ],
        },
        {
          label: '추가/삭제 이력',
          align: 'center',
          child: [
            {
              name: 'regDtStrTime',
              field: 'regDtStrTime',
              label: '추가일시',
              align: 'center',
              style: 'width:150px',
              sortable: false,
            },
            {
              name: 'regUserName',
              field: 'regUserName',
              label: '추가사용자',
              align: 'center',
              style: 'width:150px',
              sortable: false,
            },
            {
              name: 'chgDtStrTime',
              field: 'chgDtStrTime',
              label: '삭제일시',
              align: 'center',
              style: 'width:150px',
              sortable: false,
            },
            {
              name: 'chgUserName',
              field: 'chgUserName',
              label: '삭제사용자',
              align: 'center',
              style: 'width:150px',
              sortable: false,
            },
          ],
        },
      ];
    },
    getPrtr2() {
      this.$http.url = this.prtr2Url;
      this.$http.type = 'GET';
      this.$http.request(res => {
        this.prtr2rows = res.data;
      });
    },
    getHeader() {
      this.$http.url = this.headerUrl;
      this.$http.type = 'GET';
      this.$http.param = { headerType: 'check' };
      this.$http.request(res => {
        this.grid2.columns = [
          {
            name: 'chemNmEn',
            field: 'chemNmEn',
            label: '화학물질명(ENG)',
            align: 'left',
            style: 'width:220px',
            fix: true,
          },
        ];
        res.data.forEach(item => this.grid2.columns.push(item));
        this.getLaw();
      });
    },
    getLaw() {
      this.$http.url = this.reglistUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        mdmChemMaterialId: this.popupParam.mdmChemMaterialId,
      };
      this.$http.request(res => {
        this.grid2.data = res.data;
      });
    },
    getDetail() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        mdmChemMaterialId: this.popupParam.mdmChemMaterialId,
        delFlag: this.delFlag,
      };
      this.$http.request(res => {
        this.grid.data = res.data;
      });
    },
    addRow() {
      this.popupOptions.target = () => import(`${'@/pages/mdm/mam/chem/chemBasePop.vue'}`);
      this.popupOptions.title = '화학물질';
      this.popupOptions.visible = true;
      this.popupOptions.width = '60%';
      this.popupOptions.param = { type: 'multiple', isDetail: true };
      this.popupOptions.closeCallback = this.closeChemBasePopup;
    },
    closeChemBasePopup(data) {
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        data.forEach(item => {
          if (this.$_.findIndex(this.grid.data, { mdmChemId: item.mdmChemId }) === -1) {
            this.grid.data.push({
              mdmChemMaterialId: this.popupParam.mdmChemMaterialId,
              mdmChemId: item.mdmChemId,
              casNo: item.casNo,
              chemNmKr: item.chemNmKr,
              chemNmEn: item.chemNmEn,
              limitHigh: 0,
              limitLow: 0,
              limitRepval: 0,
              regulQuanti: item.regulQuanti,
              regulTwaStel: item.regulTwaStel,
              regulD10: item.regulD10,
              regulD14: item.regulD14,
              twaPpm: item.twaPpm,
              twaMm: item.twaMm,
              stelPpm: item.stelPpm,
              stelMm: item.stelMm,
              businessSecFlag: 'N',
              delFlag: 'N',
              prtrGroupId: '',
              molecularFormula: item.molecularFormula,
              boilingPoint: item.boilingPoint,
              cmrFlag: item.cmrFlag,
              maleficenceForm: item.maleficenceForm,
              maleficenceValue: item.maleficenceValue,
              maleficenceType: item.maleficenceType,
              maleficenceGrade: item.maleficenceGrade,
              dangerousClass: item.dangerousClass,
              dangerousProp: item.dangerousProp,
              dangerousName: item.dangerousName,
              calcuOriginal: item.calcuOriginal,
              calcuMultiple: item.calcuMultiple,
              hrCodeGrade: item.hrCodeGrade,
              rcode: item.rcode, // 위험문구(R-code)
              hcode: item.hcode, // 유해위험문구(H-code)
              editFlag: 'C',
              regUserId: this.$store.getters.user.userId,
            });
          }
        });
      }
    },
    saveSubstance() {
      const msg = `<div>
                  저장하시겠습니까?<br>
                  <span style="color: #c0392b;"><strong>[예]를 클릭할 시, 구성성분별 규제기준에 따라<br> 화학자재 규제사항이 자동으로 업데이트됩니다.</strong></span>
                  <span style="color: #c0392b;"><strong>※주의하시기 바랍니다.</strong></span><br>
                    <strong style="color: #d35400;">[아니오]를 클릭할 시 구성성분 정보만 저장합니다.<br> ※화학자재 규제사항은 규제정보 탭에서 직접 체크하시기 바랍니다.</strong>
                </div>`;
      window.getApp.$emit('MULTICONFIRM', {
        title: '확인',
        message: msg,
        type: 'info',
        confirmCallback: () => {
          this.$_.forEach(this.grid.data, _item => {
            _item.saveUserId = this.$store.getters.user.userId;
          });
          this.$http.url = this.autoSaveUrl;
          this.$http.type = 'POST';
          this.$http.param = this.grid.data;
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.getDetail();
            this.getLaw();
            this.$emit('setRegul');
          });
        },
        denyCallback: () => {
          this.$http.url = this.saveUrl;
          this.$http.type = 'POST';
          this.$http.param = this.grid.data;
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.getDetail();
            this.getLaw();
            this.$emit('setRegul');
          });
        },
      });
    },
    removeRow() {
      let selectData = this.$refs['substanceTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '선택된 항목이 없습니다.',
          type: 'error', // success / info / warning / error
        });
        return;
      }

      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        type: 'warning',
        confirmCallback: () => {
          selectData.forEach(item => {
            item.delFlag = 'Y';
            item.chgUserId = this.$store.state.user.userId;
          });
          this.$http.url = this.deleteUrl;
          this.$http.type = 'DELETE';
          this.$http.param = { data: selectData };
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.getDetail();
            this.getLaw();
            // this.$refs.substanceTable.compoTable.clearSelection();
          });
        },
      });
    },
    datachange(props) {
      if (props.row.editFlag !== 'C') {
        props.row.editFlag = 'U';
        props.row.chgUserId = this.$store.state.user.userId;
      }
    },
    openChemQuantity() {
      this.popupOptions.title = '규제항목 기준값 조회';
      this.popupOptions.param = {
        mdmChemMaterialId: this.popupParam.mdmChemMaterialId,
        plantCd: this.popupParam.plantCd,
      };
      this.popupOptions.target = () => import(`./chemQuantity.vue`);
      this.popupOptions.visible = true;
      this.popupOptions.width = '96%';
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
    linkClick(row) {
      this.popupOptions.title = '화학물질 상세';
      this.popupOptions.param = {
        mdmChemId: row ? row.mdmChemId : '',
      };
      this.popupOptions.target = () => import(`@/pages/mdm/mam/chem/chemBaseDetail.vue`);
      this.popupOptions.visible = true;
      this.popupOptions.isFull = false;
      this.popupOptions.width = '95%';
      this.popupOptions.closeCallback = this.closePopup;
    },
    tableDataChange(_props, _col) {
      if (_col.name === 'limitLow' || _col.name === 'limitHigh') {
        _props.row.limitRepval = (Number(_props.row.limitLow) + Number(_props.row.limitHigh)) / 2;
        _props.row.limitDisplay = _props.row.limitLow + '-' + Number(_props.row.limitHigh);
      }
    },
  },
};
</script>

<style scoped>
/* .merged-msg-container {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 380px;
  text-align: center;
  z-index: 1;
  color: #ff5722;
  font-size: 11px;
  font-weight: bold;
  background-color: #fff9e6;
  padding: 4px 12px;
  border-radius: 4px;
} */
/* :deep(.q-table td) {
  position: relative;
  overflow: visible;
} */
</style>
